import React from 'react';
import { useNavigate } from "react-router-dom";
import { ReactComponent as More } from "../../../src/icons-svg/icons/viewmore.svg"; 
import { ReactComponent as Info } from "../../../src/icons-svg/icons/information.svg";
import { ReactComponent as Trash } from "../../../src/icons-svg/icons/trash.svg";
import { ReactComponent as Pencil } from "../../../src/icons-svg/icons/pencil.svg";
import { ReactComponent as Download } from "../../../src/icons-svg/icons/download.svg";

// cell renderer component for Release Management screen
export const ReleaseCustomCellRenderer = (props) => {
    const {data, 
           type, 
          getRejectionReason, 
          handleReleaseDetails, 
          status, 
          disabledFeatures, 
          handleDeleteRelease, 
          handleDownloadReleaseNotes,
          handleApproveClick,
          handleRejectClick } = props;
    const navigate = useNavigate();

    const handleRedirect = (field) => {
        // Extract necessary data from the field or other sources
        // Redirect to another page with parameters
        navigate(`/firmwarereport`, {
          state: {
            releaseData: data,
          },
        });
      };
    
      const capitalizeDisplayValue = (cellValue) => {
        return cellValue.charAt(0).toUpperCase() + cellValue.slice(1);
      }

      const buttonDisable = (field) => {
        return !!((field === "approved" || field === "Approved") ||
          disabledFeatures.includes("Approve") ||
          (field === "rejected" || field === "Rejected") ||
          disabledFeatures.includes("Reject"))
      };

      const approveRejectButtonView = () => {
        return (
       <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {(status === "Pending" || status === "pending" || status === "All Releases") && 
          (
            <button
          className="btn btn-primary btn-sm btn-width"
          title="approve"
          data-action="approve"
          disabled={data && buttonDisable(data.approval_state)}
          onClick={() => {
            handleApproveClick(data);
          }}
        >
          {((data && data.approval_state === "approved") || (data && data.approval_state === "Approved")) ? "Approved" : "Approve"}
        </button>
          )
          }
          {" "}
          {(status === "Pending" || status === "pending" || status === "All Releases") && (
          <button
          className="btn btn-danger btn-sm btn-width"
          title="reject"
          data-action="reject"
          disabled={data && buttonDisable(data.approval_state)}
          onClick={() => {
            handleRejectClick(data);
          }}
        >
          {((data && data.approval_state === "rejected") || (data && data.approval_state === "Rejected")) ? "Rejected" : "Reject"}
        </button >
        )}
          {" "}
          <button
            className="Deletebtn btn-sm"
            size="sm"
            title="Delete"
            data-action="delete"
            disabled={disabledFeatures.includes("DeleteRelease")}
            onClick={() => {
              handleDeleteRelease(data);
            }}
          >
            <Trash />
          </button>
        </div>
        )
      }
      if (data !== null || data !== undefined) {
      const renderElement = () => {
       switch(type) {
        case "viewmore":
            return (
                <button
              className="Deletebtn btn-sm"
              size="sm"
              title="View Firmware Report"
              data-action="more"
              onClick={() => {
                handleRedirect(data);
              }}
            >
              <More/>
            </button>
            )
        case "approvalState":
            return (
                <div>
              {data && (data.approval_state === "rejected" || data.approval_state === "Rejected") ? (
                    <button
                      className="link-button"
                      onClick={(e) => getRejectionReason(data)}
                    >
                      {data && capitalizeDisplayValue(data.approval_state)}
                    </button>
                  ) : (
                    <div className={data && (data.approval_state === "approved" || data.approval_state === "Approved") && "approvalStatus"}>
                    {data && capitalizeDisplayValue(data.approval_state)}
                    </div>
                  )}
                </div>
            )
        case "details":
        return (
            <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <button
            className="Deletebtn btn-sm"
            size="sm"
            title="More Information"
            data-action="info"
            onClick={() => {
              handleReleaseDetails(data);
            }}
          >
            <Info />
          </button>
        </div>
        )
        case "approvals":
            return (
                <div>
          {approveRejectButtonView()}
                </div>
            )
            case "release_notes":
              return (
                  <button
                  className={(data && data.approval_state !== null) && data.release_notes_name !== null ? "Deletebtn btn-sm" : "Deletebtn btn-sm link-disable"}
            size="sm"
            title={data && data.release_notes_name !== null ? "Download Release Notes" : "Release Notes Not Available"}
                  data-action="download"
                  onClick={() => {
                    handleDownloadReleaseNotes(data);
                  }}
                >
                  <Download />
                </button>
              )
        default: 
        return <></>
      }
    }

    return (
        <div>
            {(data !== null || data !== undefined) && renderElement()}
      </div>
    )
  }
}

// cell renderer component for Firmware Store screen
export const FirmwareStoreCellRenderer = (props) => {
  const {data, type, handleFirmwareDetails, handleDeleteFirmware, handleEdit, handleDownloadReleaseNotes} = props;
  if (data !== null || data !== undefined) {
    const renderElement = () => {
      switch(type) {
       case "info" :
         return (
           <div
             style={{
               display: "flex",
               justifyContent: "space-between",
               alignItems: "center",
             }}
           >
             <button
               className="Deletebtn btn-sm"
               size="sm"
               title="More Information"
               data-action="info"
               onClick={() => {
                 handleFirmwareDetails(data);
               }}
             >
               <Info />
             </button>
           </div>
         )
       case "delete" :
         return (
           <>
           <button
               className="Deletebtn btn-sm"
               size="sm"
               title="Delete"
               data-action="delete"
               onClick={() => {
                 handleDeleteFirmware(data);
               }}
             >
               <Trash />
             </button>
             <button
             className="Deletebtn btn-sm"
             size="sm"
             title="Edit"
             data-action="edit"
             onClick={() => {
               handleEdit(data);
             }}
           >
             <Pencil />
           </button>
           </>
         )
         case "release_notes":
           return (
               <button
               className={(data && data.release_notes_name !== null) ? "Deletebtn btn-sm" : "Deletebtn btn-sm link-disable"}
               size="sm"
               title={(data && data.release_notes_name !== null) ? "Download Release Notes" : "Release Notes Not Available"}
               data-action="download"
               disabled={(data && data.release_notes_name === null)}
               onClick={() => {
                 handleDownloadReleaseNotes(data);
               }}
             >
               <Download />
             </button>
           )
         default :
         return <></>
      }
     }
     return (
      <div>
        {(data !== null || data !== undefined) && renderElement()}
      </div>
    )
  }

}

// cell renderer component for Site Details screen
export const SiteDetailsCellRenderer = (props) => {
  const {data, type, handleSiteDetails, disabledFeatures, handleDeleteSite, handleEdit, handleDownloadNetworkDiagram} = props;
  const renderElement = () => {
   switch(type) {
    case "info" :
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <button
            className="Deletebtn btn-sm"
            size="sm"
            title="More Information"
            data-action="info"
            onClick={() => {
              handleSiteDetails(data);
            }}
          >
            <Info />
          </button>
        </div>
      )
      case "edit":
        return (
          <>
          <button
            className="Deletebtn btn-sm"
            size="sm"
            title="Delete"
            data-action="delete"
            disabled={disabledFeatures.includes("DeleteSite")}
            onClick={() => {
              handleDeleteSite(data);
            }}
          >
            <Trash />
          </button>
          <button
            className="Deletebtn btn-sm"
            size="sm"
            title="Edit"
            data-action="edit"
            disabled={disabledFeatures.includes("DeleteSite")}
            onClick={() => {
              handleEdit(data);
            }}
          >
            <Pencil />
          </button>
          </>
        )
        case "network_diagram":
              return (
                  <button
                  className={(data && data.network_digram_path !== null) ? "Deletebtn btn-sm" : "Deletebtn btn-sm link-disable"}
            size="sm"
            title={data && data.network_digram_path !== null ? "Download Network Diagram" : "Network Diagram Is Not Available"}
                  data-action="download"
                  onClick={() => {
                    (data && data.network_digram_path !== null) && handleDownloadNetworkDiagram(data);
                  }}
                >
                  <Download />
                </button>
              )
      default :
      return <></>
   }
  }

  return (
    <div>
      {renderElement()}
    </div>
  )
}

// cell renderer component for User Management screen
export const UserDetailsCellRenderer = (props) => {
  const {data, type, handleUserDetails, disabledFeatures, handleDeleteUser, handleEdit} = props;
  const renderElement = () => {
   switch(type) {
    case "info" :
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <button
            className="Deletebtn btn-sm"
            size="sm"
            title="More Information"
            data-action="info"
            onClick={() => {
              handleUserDetails(data);
            }}
          >
            <Info />
          </button>
        </div>
      )
      case "edit":
        return (
          <>
          <button
            className="Deletebtn btn-sm"
            size="sm"
            title="Delete"
            data-action="delete"
            disabled={disabledFeatures.includes("DeleteUser")}
            onClick={() => {
              handleDeleteUser(data);
            }}
          >
            <Trash />
          </button>
          <button
            className="Deletebtn btn-sm"
            size="sm"
            title="Edit"
            data-action="edit"
            disabled={disabledFeatures.includes("DeleteSite")}
            onClick={() => {
              handleEdit(data);
            }}
          >
            <Pencil />
          </button>
          </>
        )
      default :
      return <></>
   }
  }

  return (
    <div>
      {renderElement()}
    </div>
  )
}

export const ContractDetailsCellRenderer = (props) => {
  const {data, type, disabledFeatures, handleDeleteContract, handleEdit, handleContractDetails} = props;
  const renderElement = () => {
   switch(type) {
      case "edit":
        return (
          <>
          <button
            className="Deletebtn btn-sm"
            size="sm"
            title="Delete"
            data-action="delete"
            disabled={disabledFeatures.includes("DeleteContract")}
            onClick={() => {
              handleDeleteContract(data);
            }}
          >
            <Trash />
          </button>
          <button
            className="Deletebtn btn-sm"
            size="sm"
            title="Edit"
            data-action="edit"
            disabled={disabledFeatures.includes("DeleteContract")}
            onClick={() => {
              handleEdit(data);
            }}
          >
            <Pencil />
          </button>
          </>
        )
        case "info" :
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <button
            className="Deletebtn btn-sm"
            size="sm"
            title="More Information"
            data-action="info"
            onClick={() => {
              handleContractDetails(data);
            }}
          >
            <Info />
          </button>
        </div>
      )
      default :
      return <></>
   }
  }

  return (
    <div>
      {renderElement()}
    </div>
  )
}



